import { Component, OnInit } from '@angular/core';

interface BootcampCourse {
image: string;
title: string;
highlight: string;
features:string[];
price: string;
bookLink?: string; // Optional link for booking
detailsLink?: string; // Optional link for more details
}

@Component({
    selector: 'app-bootcamp',
    templateUrl: './bootcamp.component.html',
    styleUrls: ['./bootcamp.component.css'],
    standalone: false
})
export class BootcampComponent  {

   bootcampCourses: BootcampCourse[] = [
    {
      image: 'assets/images/sb-nvr.png',
      title: '11+ SUMMER BOOT-CAMP',
      highlight: 'NON-VERBAL REASONING',
      features: [
        'Master Non Verbal Reasoning',
        'Real Exam Practice',
        'Track Progress With RAR',
        
      ],
      price: '£129',
      bookLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/da9b98644f1625caf75c90619133bd36/book-a-slot',
    detailsLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/da9b98644f1625caf75c90619133bd36'
    },
    {
      image: 'assets/images/sb-maths.png',
      title: '11+ SUMMER BOOT-CAMP',
      highlight: 'MATHS',
      features: [
        'Master Key Maths Concepts',
        'Strengthen Problem-Solving Skills',
        'Build Exam Confidence'
      ],
      price: '£129',
      bookLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/17b02770c0dd046868578c7fda6a0049/book-a-slot',
      detailsLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/17b02770c0dd046868578c7fda6a0049'
    },
    {
      image: 'assets/images/sb-vr.png',
      title: '11+ SUMMER BOOT-CAMP',
      highlight: 'VERBAL REASONING',
      features: [
        'Sharpen Logical Thinking',
        'Build Vocabulary Skills',
        'Boost Accuracy and Speed'
      ],
      price: '£129',
      bookLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/1c35c8c1b1953b21235495c2a24b025c/book-a-slot',
    detailsLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/1c35c8c1b1953b21235495c2a24b025c'
    },
    {
      image: 'assets/images/sb-1.png',
      title: '11+ SUMMER BOOT-CAMP',
      highlight: 'ENGLISH EDITION',
      features: [
        'Excel in English Comprehension',
        'Sharpen Creative Writing Skills',
        'Master Grammar and Vocabulary'
      ],
      price: '£129',
      bookLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/8c7afe206774fbf0208c87f42b055a6d/book-a-slot',
    detailsLink: 'https://www.sehyog.co.uk/11plus-help-club/category/11-rapid-course/8c7afe206774fbf0208c87f42b055a6d'
    },
  ];

}
